import { createCache } from "react-fetching-library";

export default createCache(
  action => action.endpoint.startsWith("/asset"),
  response => new Date().getTime() - response.timestamp < 3600000,
);
